import axios from 'axios'
import QS from 'qs'

// 默认地址
axios.defaults.baseURL = "http://admin.origination.cn/"

// 请求头设置
axios.defaults.headers.post['Content-Type'] = 'application/X-WWW-FORM-URLENCODED';

// get请求
export function get(url,params){  
  return new Promise((resolve,reject) => {
    axios.get(url,{
      params:params
    }).then(res=> {
      resolve(res.data)
    }).catch(err => {
      reject(err.data)
    })
  })
}

// post请求
export function post(url,params){
  return new Promise((resolve,reject) => {
    axios.post(url,QS.stringify(params))
    .then(res => {
      resolve(res.data)
    })
    .catch(err => {
      reject(err.data)
    })
  })
}

// 获取当前页面域名url
export function getURL(){
  return window.location.href
}

// 为图片添加域名
export function addName(str){
  let reg = /<img(.*?)src="\/ueditor\/(.*?)"(.*?)>/g
  let replacement = '<img$1src="http://admin.origination.cn/ueditor/$2"$3>'
  return str.replace(reg,replacement)
}



// WEBPACK FOOTER //
// ./src/api/index.js